import {
    DomainInitPayload,
    OfferDisplayInfo,
    SmsSubscription,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getPackageCmsDisplayName } from '@sxm-de/dev-kits/web-sdk/domains/offers';

import { getIdentity } from '@sxm-de/dev-kits/web-sdk/domains/identity';

export type GetSmsSubscriptionsWithOfferDetailsFn = () => Promise<{
    subscriptions: SmsSubscription[];
    offerDisplayInfo: OfferDisplayInfo;
}>;

export function initGetSmsSubscriptionsWithOfferDetailsFn({
    dependencies,
}: DomainInitPayload): GetSmsSubscriptionsWithOfferDetailsFn {
    const { microservicesSdk } = dependencies;
    return async () => {
        try {
            const { handle } = await getIdentity(dependencies);
            const email = handle?.emailAddress || handle?.username;

            if (!email) {
                throw new Error('Handle not found in auth session');
            }
            const response =
                await microservicesSdk.domains.identity.getAccountByEmail({
                    email,
                });
            const smsPackageIds: string[] = [];
            response.forEach(({ plans }) => {
                plans.forEach((plan) => {
                    const { packageName } = plan;
                    const smsPackageId = normalizePackageId(packageName);
                    plan.packageId = smsPackageId;
                    if (!smsPackageIds.includes(smsPackageId)) {
                        smsPackageIds.push(smsPackageId);
                    }
                });
            });
            const offerDisplayInfo = await getPackageCmsDisplayName(
                { smsPackageIds },
                dependencies,
            );
            // TODO: add analytics
            return { subscriptions: response ?? [], offerDisplayInfo };
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}

function normalizePackageId(packageId: string): string {
    if (packageId.startsWith('3_')) {
        return packageId.replace(/^3_/, 'SXM_');
    }
    return packageId;
}
